/* eslint-disable max-classes-per-file */
import config from '../../../config'
import { appendQueryParam } from './api-util'
import http from './http-util'

const channelType = 'MERCHANT_PORTAL'
class PaymentMethodsApi {
  static application = class ApplicationApi {
    static formSpec = (applicationInfo, token) => {
      let queryParams = ''
      queryParams = appendQueryParam(
        queryParams,
        'amount',
        applicationInfo.amount,
      )
      return http.get(
        token,
        `${config.paymentMethodServiceUrl}/payment_methods/id/${applicationInfo.paymentMethodId}/channel_type/${channelType}/application_formspec${queryParams}`,
        config.requestTimeoutFormSpec,
      )
    }
  }

  static getPaymentMethodCostAlternatives =
    ({ amount, paymentMethodId }) =>
    token => {
      let queryParams = ''
      queryParams = appendQueryParam(queryParams, 'amount', amount)
      return http.get(
        token,
        `${config.paymentMethodServiceUrl}/payment_methods/id/${paymentMethodId}/channel_type/MERCHANT_PORTAL/price_signage_slider${queryParams}`,
        config.requestTimeoutPaymentMethods,
      )
    }

  static getPaymentMethods = ({ governmentId, customerType }, token) => {
    let queryParams = ''
    queryParams = appendQueryParam(queryParams, 'language', 'sv')
    queryParams = appendQueryParam(
      queryParams,
      'channelType',
      'MERCHANT_PORTAL',
    )
    queryParams = appendQueryParam(queryParams, 'customerType', customerType)

    return http.get(
      token,
      `${config.paymentMethodServiceUrl}/payment_methods/${governmentId}${queryParams}`,
      config.requestTimeoutPaymentMethods,
    )
  }

  static storePaymentMethods = (
    { typeFilters, customerType, channel },
    token,
  ) => {
    let queryParams = ''

    if (typeFilters) {
      typeFilters.forEach(typeFilter => {
        queryParams = appendQueryParam(queryParams, 'typeFilter', typeFilter)
      })
    }
    if (customerType) {
      queryParams = appendQueryParam(queryParams, 'customerType', customerType)
    }
    queryParams = appendQueryParam(queryParams, 'channelType', channel)

    return http.get(
      token,
      `${config.paymentMethodServiceUrl}/payment_methods/store${queryParams}`,
    )
  }

  static paymentPerMonth = (data, token) => {
    let queryParams = ''
    queryParams = appendQueryParam(queryParams, 'amount', data.amount)
    queryParams = appendQueryParam(queryParams, 'repaymentMonths', data.months)
    return http.get(
      token,
      `${config.paymentMethodServiceUrl}/payment_methods/id/${data.method}/channel_type/${channelType}/price_signage${queryParams}`,
    )
  }

  static customerTypes = token => {
    return http.get(
      token,
      `${config.paymentMethodServiceUrl}/payment_methods/channel_type/${channelType}/customer_types`,
    )
  }
}

export default PaymentMethodsApi
